import * as React from 'react';
import { connect } from 'react-redux';
import { socketInitate, setDisplayIdAndGetTokensDataRequest, setDisplayIdAndGetTokensDataResponse, getTokensDataWithSocketRequest } from '../../../store/actions';
import { SuperParentContext } from './displayboardcontext';
import { interval } from 'rxjs';
import {
    ThemeOneDisplayboardContainer,
    ThemeOneAlert,
    ThemeOneFooter,
    ThemeOneParentManager,
    ThemeOneTopbar,
    ThemeOnePopupAlert
} from '../Container/displayboardindex';
import './Displayboard.scss';
import { IDisplayThemes } from '../../../models/utilitiesModel';
import { getIntervalCall, getAudioFiles, getApiServiceUrlByComponentAndMethod, getsocketEnable } from '../../../helpers/helpersIndex';
import PageUnAuthorized from '../../ErrorPages/pages-undisplay';
import ErrorUnTheam from '../../ErrorPages/pages-untheam';
import Stomp from 'stompjs';
import SockJS from 'sockjs-client';

let subscribe;
let mysocketConnect;
let ws: any;
let stompClient;
let socketConnect: boolean = false;

class Displayboard extends React.Component<any, any> {

    constructor(props) {
        super(props);
        const paramKey = 'displayid';
        let displayId: any = new URLSearchParams(this.props.location.search).toString()?.split('=')[0];
        displayId = displayId.toLowerCase() === paramKey ? new URLSearchParams(this.props.location.search).get(displayId) : '';

        this.state = {
            themeOne: {
                themeOneAlert: ThemeOneAlert,
                themeOneFooter: ThemeOneFooter,
                themeOneParentManager: ThemeOneParentManager,
                themeOneTopbar: ThemeOneTopbar,
                themeOnePopupAlert: ThemeOnePopupAlert,
                audioPath: `assets/audio/${getAudioFiles('theme1')}`
            },
            displayId: displayId
        }
    }

    componentDidMount() {

        if (this.state.displayId) {
            if (getsocketEnable()) {
                // Socket Implementaion
                this.props.socketInitate();
                this.initializeWebSocketConnection("/chat/" + this.state.displayId);
                mysocketConnect = interval(30000).subscribe(data => {
                    if (stompClient.connected) {
                        console.log("123=>", stompClient.connected, socketConnect);
                        if (socketConnect)
                            socketConnect = false;
                        else {
                            stompClient.connected = false;
                            stompClient.connectCallback();
                        }
                    }
                });
            } else {
                this.props.setDisplayIdAndGetTokensDataRequest(this.state.displayId, true);
                subscribe = interval(1000 * getIntervalCall()).subscribe(() => {
                    if (this.props.theme && this.props.theme !== '')
                        this.props.setDisplayIdAndGetTokensDataRequest(this.state.displayId, false);
                });
            }
        }
    }

    componentWillUnmount() {
        if (subscribe)
            subscribe.unsubscribe();
        if (stompClient != null) {
            if (stompClient?.connected)
                stompClient?.disconnect();
            // this.stompClient.close();
        }
        if (mysocketConnect)
            mysocketConnect.unsubscribe();
        if (ws != null) {
            ws.close();
        }
        socketConnect = false;
    }

    initializeWebSocketConnection(id) {
        console.log("initializeWebSocketConnection_id =>1 ", id);
        let _apiurlsdetials = getApiServiceUrlByComponentAndMethod("Servingdisplay", "getServingDisplayfromSocket")
        console.log("URL_Get_from_config : =====> ", _apiurlsdetials);
        if (_apiurlsdetials) {
            let dis = this;
            console.log("URL_Get_from_config : ---->  ", _apiurlsdetials.url);
            ws = new SockJS(_apiurlsdetials.url);
            stompClient = Stomp.over(ws);
            let socketStartsub = false;
            stompClient.connect({ "name": "servingDisplay", "display_id": this.state.displayId }, function (frame) {
                console.log('WebSocket_message.body=>', frame, socketStartsub);
                stompClient.subscribe(id, (message) => {
                    socketConnect = true;
                    console.log('WebSocket_message.body=>', message, socketConnect, socketStartsub);
                    let response = JSON.parse(message.body);
                    console.log("WebSocket_response =>", response);
                    if (response.status)
                        dis.props.getTokensDataWithSocketRequest(response);
                    else
                        dis.props.setDisplayIdAndGetTokensDataResponse('did', '', undefined, []);
                });
            }, () => {
                console.log('WebSocket_connection failed.');
                this.props.setDisplayIdAndGetTokensDataResponse('did', '', undefined, []);
                setTimeout(() => {
                    this.initializeWebSocketConnection(id);
                }, 5000);
            });
        }
        else {
            console.log("URL Get from config : ---->  ", "Url not found..");
        }
    }

    getThemeContainer = (displayId, value) => {
        console.log('getThemeContainer=>', displayId, value);

        if (displayId && displayId !== '') {
            switch (value) {
                case IDisplayThemes.THEME1:
                    return <ThemeOneDisplayboardContainer />;
                default:
                    return <ErrorUnTheam />;
            }
        }
        else
            return <PageUnAuthorized />
    }

    render() {
        const { displayId, theme } = this.props;
        // console.log("displayId=>", (this.state.displayId && displayId && displayId !== 'did'), (!this.state.displayId || (displayId && displayId === 'did')));
        return (
            <>
                {this.state.displayId && displayId && displayId !== 'did' && <SuperParentContext.Provider value={this.state.themeOne}>
                    {this.getThemeContainer(displayId, theme)}
                </SuperParentContext.Provider>}
                {(!this.state.displayId || (displayId && displayId === 'did')) && <PageUnAuthorized />}
                {!(this.state.displayId && displayId && displayId !== 'did') && !(!this.state.displayId || (displayId && displayId === 'did')) && <><div className="appLoading">Loading <div className="lds-ring"><div></div><div></div><div></div><div></div></div></div></>}
            </>
        );
    }
}
const mapStateToProps = state => ({
    displayId: state?.displayBoardReducer?.displayId,
    theme: state?.displayBoardReducer?.theme
});
export default connect(mapStateToProps, { setDisplayIdAndGetTokensDataRequest, setDisplayIdAndGetTokensDataResponse, getTokensDataWithSocketRequest, socketInitate })(Displayboard); 
